<!--Div a mostrar cuando estén cargando los datos-->
<div class="alert alert-light text-center" *ngIf="loading">
  <p class="d-flex justify-content-center">
    <mat-spinner></mat-spinner>
  </p>
</div>

<section class="mt-3" *ngIf="!loading">
  <form [formGroup]="cotizacionForm" (ngSubmit)="calcularAranceles()">
    <div class="form-body">

      <div class="row">
        <mat-form-field class="col-12 col-md-6">
          <mat-label>Dependencia</mat-label>
          <mat-select formControlName="idDependencia">
            <mat-option *ngFor="let dependencia of dependencias"
              [value]="dependencia.idDependencia">{{dependencia.nombre}}</mat-option>
          </mat-select>
          <mat-error *ngIf="usoObraNoValido">*Campo requerido</mat-error>
        </mat-form-field>

        <div class="col-12 col-md-6" *ngIf="selectedDependencia">
          <table cellpadding="3">
            <tr>
              <td><strong>Dependencia</strong></td>
              <td>{{selectedDependencia.nombre}}</td>
            </tr>
            <tr>
              <td><strong>Puesto</strong></td>
              <td>{{selectedDependencia.puesto}}</td>
            </tr>
            <tr>
              <td><strong>Titular</strong></td>
              <td>{{selectedDependencia.titular}}</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="row">
        <mat-form-field class="col-12 col-md-6">
          <mat-label>Nombre del D.R.O. o Corresponsable</mat-label>
          <input matInput value="{{fullNameSocioDesencriptado}}" disabled>
        </mat-form-field>

        <mat-form-field class="col-12 col-md-6">
          <mat-label>Propietario</mat-label>
          <input matInput formControlName="propietario" placeholder="Propietario de la obra">
          <mat-error *ngIf="propietarioNoValido">*Campo requerido</mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field class="col-12 col-md-6">
          <mat-label>Uso de obra</mat-label>
          <mat-select formControlName="idUsoDeObra" (selectionChange)="onChangeFactorCalidad($event.value)">
            <mat-option *ngFor="let obra of usoDeObra" [value]="obra.idUsoDeObra">{{obra.uso}}</mat-option>
          </mat-select>
          <mat-error *ngIf="usoObraNoValido">*Campo requerido</mat-error>

        </mat-form-field>

        <div class="d-flex align-items-center col-12 col-md-6">
          <mat-form-field class="flex-grow-1">
            <mat-label>Factor de calidad</mat-label>
            <mat-select formControlName="idFactorDeCalidad" [disabled]="factorDeCalidad.length == 0">
              <mat-option *ngFor="let factor of factorDeCalidad" [value]="factor.idFactor">{{factor.calidad}}</mat-option>
            </mat-select>
            <mat-error *ngIf="factorNoValido">*Campo requerido</mat-error>
          </mat-form-field>
          <button type="button" (click)="openModalTable()" class="btn btn-sm" style="background-color: transparent; border: none; width: 30px; height: 30px; padding: 0;">
            <mat-icon style="font-size: 20px; color: black;">info</mat-icon>
          </button>                 
        </div>
        
        
      </div>

      <div class="row">
        <mat-form-field class="col-12 col-md-6">
          <mat-label>Nombre de la obra</mat-label>
          <textarea matInput formControlName="nombreObra" matTextareaAutosize matAutosizeMinRows="3"
            matAutosizeMaxRows="8"></textarea>
          <mat-error *ngIf="nombreObraNoValido">*Campo requerido</mat-error>
        </mat-form-field>

        <mat-form-field class="col-12 col-md-6">
          <mat-label>Ubicación</mat-label>
          <textarea matInput formControlName="ubicacion" matTextareaAutosize matAutosizeMinRows="3"
            matAutosizeMaxRows="8"></textarea>
          <mat-error *ngIf="ubicacionNoValido">*Campo requerido</mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field class="col-12 col-md-4">
          <mat-label>Superficie a construir (m²)</mat-label>
          <input matInput formControlName="metros2" (keypress)="validaNumeros($event)" maxlength="10">
          <mat-error *ngIf="metrosNoValido">*Campo requerido</mat-error>
          <mat-error *ngIf="metrosMinimos">La superficie mínima es de 61m²</mat-error>
          <mat-error *ngIf="metrosMaximos">La superficie no debe exceder los 10,000m²</mat-error>
        </mat-form-field>

        <mat-form-field class="col-12 col-md-4">
          <mat-label>Tipo de Obra</mat-label>
          <mat-select formControlName="idTipoDeObra">
            <mat-option *ngFor="let obra of obras"
              [value]="obra.idTipoDeObra">{{obra.descripcion}}</mat-option>
          </mat-select>
          <mat-error *ngIf="usoObraNoValido">*Campo requerido</mat-error>
        </mat-form-field>

        <div class="row" >
          <div class="col-5">
            <mat-checkbox formControlName="esCDA">Es CDA <span class="highlighted">( {{socio.cda}} )</span></mat-checkbox>
            <mat-error *ngIf="selectedCheckbox" style="font-size: 8px;">* Al menos un checkbox es requerido.</mat-error>
          </div>

          <div class="col-2"></div>
        
          <div class="col-5">
            <mat-checkbox formControlName="esDRO">Es DRO <span class="highlighted">( {{socio.dro}} )</span></mat-checkbox>
            <mat-error *ngIf="selectedCheckbox" style="font-size: 8px;">* Al menos un checkbox es requerido.</mat-error>
          </div>
        </div>
        
        
      </div>

      <div class="row">
        <mat-form-field class="col-12 col-md-4">
          <mat-label>S.M.V. en la zona (aplicable) ($)</mat-label>
          <input matInput formControlName="salarioMinimoVigente">
        </mat-form-field>

        <mat-form-field class="col-12 col-md-4">
          <mat-label>Índice a aplicar según tabla de arancel</mat-label>
          <input matInput formControlName="indiceTablaArancel">
        </mat-form-field>
      </div>

      <small class="ml-3 mb-2">Fuente:
        https://www.gob.mx/conasami/documentos/tabla-de-salarios-minimos-generales-y-profesionales-por-areas-geograficas</small>

      <div class="row d-flex justify-content-end">
        <button [disabled]="disableButton" type="submit" class="btn btn-primary">Calcular</button>
      </div>

    </div>
  </form>

  <hr>

  <form [formGroup]="arancelForm" (ngSubmit)="saveCotizacion()">
    <div class="form-body">

      <div class="header-container d-flex justify-content-between">
        <h4 class="color-blue-cat">ARANCEL DE TARIFAS MINIMAS PARA DRO</h4>
      </div>

      <div class="row">
        <div class="col-12 col-md-8">
          <div class="alert alert-info" role="alert">
            TARIFA APLICABLE: (Salario Mínimo Diario Vigente) x (Factor) x
            (Superficie en metros cuadrados)
          </div>
          <div class="alert alert-info" role="alert">
            Pago en línea genera un cargo adicional del 2.9% por comisión bancaria.
          </div>
        </div>
        <div class="col-12 col-md-4 justify-content-endf">
          <mat-form-field class="">
          <mat-label>Importe total de aranceles</mat-label>
            <input matInput value="{{ importeTotalArancel | currency : 'MXN' }}" disabled />
        </mat-form-field>

        <dl class="justify-content-end mb-0">
          <dt class="">Total sin I.V.A.</dt>
          <dd class=" pl-0" *ngIf="importeTotalArancel != null">{{importeTotalArancel | currency: 'MXN'}}</dd>
          <dd class=" text-muted pl-0" *ngIf="importeTotalArancel == null">$0.00</dd>
        </dl>
  
        <dl class="justify-content-end mb-0">
          <dt class="">16% I.V.A.</dt>
          <dd class=" pl-0" *ngIf="arancelTotalIVA != null">{{arancelTotalIVA | currency:'MXN'}}</dd>
          <dd class=" text-muted pl-0" *ngIf="arancelTotalIVA == null">$0.00</dd>
        </dl>
  
        <dl class="justify-content-end mb-0">
          <dt class="">Importe Neto</dt>
          <dd class=" pl-0" *ngIf="importeNeto != null">{{importeNeto | currency:'MXN'}}</dd>
          <dd class=" text-muted pl-0" *ngIf="importeNeto == null">$0.00</dd>
        </dl>
  
        <dl class="justify-content-end mb-0" *ngIf="rf['esDRO'].value && rf['esCDA'].value && rf['esDRO'].value">
          <dt class="">Arancel DRO</dt>
          <dd class=" pl-0" *ngIf="porcentajeCAT != null">{{porcentajeCAT | currency:'MXN'}}</dd>
          <dd class=" text-muted pl-0" *ngIf="porcentajeCAT == null">$0.00</dd>
        </dl>
        
        <dl class="justify-content-end mb-0" *ngIf="rf['esCDA'].value && rf['esDRO'].value">
          <dt class="">Arancel CDA</dt>
          <dd class=" pl-0" *ngIf="arancelCDA != null">{{arancelCDA | currency:'MXN'}}</dd>
          <dd class=" text-muted pl-0" *ngIf="arancelCDA == null">$0.00</dd>
        </dl>
  
        <dl class="justify-content-end mb-0">
          <dt class="">Arancel CAT</dt>
          <dd class=" pl-0" *ngIf="porcentajeCAT != null">{{ getCalcularArancel() | currency:'MXN' }}</dd>
          <dd class=" text-muted pl-0" *ngIf="porcentajeCAT == null">$0.00</dd>
        </dl>   
        
        <dl class="justify-content-end mb-0" *ngIf="rf['factor'].value">
          <div class=" d-flex align-items-center">
            <button mat-icon-button aria-label="Info" matTooltip="Al hacer este pago en línea el valor del producto será {{getCalcularFactorArancel()}}" matTooltipPosition="below" class="btn btn-sm custom-info-button">
              <mat-icon style="font-size: 20px; color: black;">info</mat-icon>
            </button>
          </div>
        </dl>
        </div>
      </div>

      <!-- <div class="header-container d-flex justify-content-between flex-wrap flex-sm-nowrap">
        <div class="alert alert-info" role="alert">
          TARIFA APLICABLE: (Salario Mínimo Diario Vigente) x (Factor) x
          (Superficie en metros cuadrados)
        </div>
        <mat-form-field class="col-12 col-md-4">
          <mat-label>Importe total de aranceles</mat-label>
          <input matInput value="{{ importeTotalArancel | currency : 'MXN' }}" disabled />
        </mat-form-field>
      </div> -->

      

      <hr>

      <div class="row">
        <div class="col-md-6 col-12">
          <h4 class="color-blue-cat">COSTO POR ETAPAS</h4>
          <table mat-table [dataSource]="dataSourceCPE" class="w-100 table-hover table-responsive-md">
            <!--Columna Etapa-->
            <ng-container matColumnDef="etapa">
              <td mat-cell *matCellDef="let element">{{ element.etapa }}</td>
            </ng-container>

            <!--Columna Costo-->
            <ng-container matColumnDef="costo">
              <td mat-cell *matCellDef="let element" class="currency-align">
                {{ element.costo | currency : "MXN" }}
              </td>
            </ng-container>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsCPE"></tr>
          </table>
        </div>
        <div class="col-md-6 col-12">
          <h4 class="color-blue-cat">TARIFAS PARA CORRESPONSABLES</h4>
          <div class="alert alert-info" role="alert">
            Los porcentajes e importes expresados son adicionales al cobro del
            concepto de Dirección Responsable de Obra
          </div>

          <table mat-table [dataSource]="dataSource" class="w-100 table-hover table-responsive-md">
            <!--Columna Corresponsal-->
            <ng-container matColumnDef="corresponsal">
              <td mat-cell *matCellDef="let element">
                {{ element.corresponsal }}
              </td>
            </ng-container>

            <!--Columna Monto de Arancel-->
            <ng-container matColumnDef="montoArancel">
              <td mat-cell *matCellDef="let element" class="currency-align">
                {{ element.arancel | currency : "MXN" }}
              </td>
            </ng-container>

            <!--Columna Porcentaje-->
            <ng-container matColumnDef="porcentaje">
              <td mat-cell *matCellDef="let element" class="currency-align">
                {{ element.porcentaje }}%
              </td>
            </ng-container>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>

          <div class="alert alert-secondary mt-5" role="alert">
            <ul>
              <li>
                Los Corresponsables en Instalaciones Electro-Mecánicas en
                Edificaciones se sujetarán al Arancel establecido por el CIME
                Tabasco.
              </li>
              <li>
                Los importes indicados incluyen la Cuota por Arancel al Colegio
                Respectivo.
              </li>
            </ul>
          </div>
        </div>
      </div>

      <hr>

      <div class="form-actions">
        <div class="text-right">
          <button mat-raised-button type="submit" class="btn-blue-cat mr-2">
            {{textButton}}
          </button>

          <!-- <button mat-raised-button type="button" class="btn-blue-cat" (click)="imprimirPDF()" [disabled]="importeTotalArancel == null">
            Imprimir cotización
          </button> -->
        </div>
      </div>
    </div>
  </form>


</section>

<!----Plantilla HTML para generar el PDF e imprimirlo-->
<div class="d-none">
  <div id="pruebaJS">
    <!---Primera hoja de la cotización-->
    <table style="width: 100%;">
      <tr>
        <td style="width: 15;">
          <img src="https://arquitab.org.mx/assets/img/logo_cotizacion_2.png" width="50">
        </td>
        <th style="width: 70; font-size: 11.5px;">
          ARANCEL DE TARIFA MÍNIMA APLICABLE POR D.R.O. Y
          CORRESPONSABLE
          PARA OBRA NUEVA O AMPLIACIÓN EN EL ESTADO DE TABASCO
        </th>
        <td style="width: 15; text-align: right;">
          <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS9prV8FFAA3lytEXResANGi9cG6mcKMwuUyw&usqp=CAU"
            width="50">
        </td>
      </tr>
    </table>

    <table style="width: 100%;">
      <tr>
        <td style="width: 40%; vertical-align: baseline;">
          <h6 style="font-size: 11.5px;">1° Factor de calidad según tabla</h6>
          <table class="table-factor" style="font-size: 8px; text-align: center;">
            <tr>
              <th>USO</th>
              <th>CALIDAD</th>
              <th>Fact. Calidad</th>
            </tr>
            <tr>
              <td rowspan="4">VIVIENDA UNIFAMILIAR</td>
              <td>INT SOCIAL</td>
              <td>1.00</td>
            </tr>
            <tr>
              <td>MEDIA</td>
              <td>1.04</td>
            </tr>
            <tr>
              <td>PRIMERA</td>
              <td>1.08</td>
            </tr>
            <tr>
              <td>LUJO</td>
              <td>1.12</td>
            </tr>

            <tr>
              <td rowspan="5">VIVIENDA MULTIFAMILIAR PLURIFAMILIAR O CONJUNTOS</td>
              <td>INT SOCIAL</td>
              <td>1.04</td>
            </tr>
            <tr>
              <td>MEDIA</td>
              <td>1.08</td>
            </tr>
            <tr>
              <td>PRIMERA</td>
              <td>1.12</td>
            </tr>
            <tr>
              <td>LUJO</td>
              <td>1.16</td>
            </tr>
            <tr>
              <td>OBRA EXTERIOR</td>
              <td>1.00</td>
            </tr>

            <tr>
              <td rowspan="5">EDIFICIOS COMERCIALES O MIXTOS</td>
              <td>SEGUNDA</td>
              <td>1.02</td>
            </tr>
            <tr>
              <td>MEDIA</td>
              <td>1.06</td>
            </tr>
            <tr>
              <td>PRIMERA</td>
              <td>1.10</td>
            </tr>
            <tr>
              <td>LUJO</td>
              <td>1.14</td>
            </tr>
            <tr>
              <td>OBRA EXTERIOR</td>
              <td>1.00</td>
            </tr>

            <tr>
              <td rowspan="3">HOTEL ZONA URBANA</td>
              <td>1 Y 2 ESTRELLAS</td>
              <td>1.02</td>
            </tr>
            <tr>
              <td>3 A 5 ESTRELLAS</td>
              <td>1.06</td>
            </tr>
            <tr>
              <td>OBRA EXTERIOR</td>
              <td>1.00</td>
            </tr>

            <tr>
              <td rowspan="3">ZONA INDUSTRIAL</td>
              <td>NAVE INDUSTRIAL</td>
              <td>1.00</td>
            </tr>
            <tr>
              <td>MIXTO</td>
              <td>1.04</td>
            </tr>
            <tr>
              <td>OBRA EXTERIOR</td>
              <td>1.00</td>
            </tr>

            <tr>
              <td rowspan="3">EDIFICIOS PÚBLICOS</td>
              <td>HOSPITAL</td>
              <td>1.20</td>
            </tr>
            <tr>
              <td>OTROS</td>
              <td>1.06</td>
            </tr>
            <tr>
              <td>OBRA EXTERIOR</td>
              <td>1.00</td>
            </tr>
          </table>

          <table style="width: 100%; font-size: 11.5px;">
            <tr>
              <th style="text-align: left;">Folio</th>
            </tr>
            <tr>
              <td style="color: red;">SIN VALOR</td>
            </tr>

            <tr>
              <th style="text-align: left;">Obra</th>
            </tr>
            <tr>
              <td>{{obra}}</td>
            </tr>

            <tr>
              <th style="text-align: left;">Ubicación</th>
            </tr>
            <tr>
              <td>{{ubicacion}}</td>
            </tr>

            <tr>
              <th style="text-align: left;">Propietario</th>
            </tr>
            <tr>
              <td>{{propietario}}</td>
            </tr>

            <tr>
              <th style="text-align: left;">Nombre D.R.O. o Corresponsable</th>
            </tr>
            <tr>
              <td>{{fullNameSocioDesencriptado}}</td>
            </tr>
          </table>
        </td>

        <td style="width: 60%; vertical-align: baseline; font-size: 11.5px !important; padding-left: 25px;">
          <table>
            <tr>
              <th style="text-align: left;" colspan="2">2° Superficie a construir</th>
              <td style="text-align: center;">{{calculoCotizacion.metros2}} m²</td>
            </tr>

            <tr>
              <th style="text-align: left;" colspan="2">3° Índice a aplicar según tabla de arancel</th>
              <td style="text-align: center;">{{indiceArancel}}</td>
            </tr>

            <tr>
              <th style="text-align: left;" colspan="2">4° S.M.V. en la zona (aplicable)</th>
              <td style="text-align: center;">{{smv | currency:'MXN'}}</td>
            </tr>

            <tr>
              <td colspan="3">
                <h4>ARANCEL DE TARIFAS MÍNIMAS PARA D.R.O.</h4>
              </td>
            </tr>

            <tr>
              <th style="text-align: left;" colspan="2">A) Importe total de Aranceles</th>
              <td style="text-align: center;">{{importeTotalArancel | currency: 'MXN'}}</td>
            </tr>

            <br>

            <tr>
              <th colspan="2" style="text-align: right; color: #2054A1; padding-right: 45px;">Total sin I.V.A.</th>
              <td style="text-align: center;">{{importeTotalArancel | currency: 'MXN'}}</td>
            </tr>

            <tr>
              <th colspan="2" style="text-align: right; color: #2054A1; padding-right: 45px;">16% I.V.A.</th>
              <td style="text-align: center;">{{arancelTotalIVA | currency:'MXN'}}</td>
            </tr>

            <tr>
              <th colspan="2" style="text-align: right; color: #2054A1; padding-right: 45px;">Importe Neto</th>
              <td style="text-align: center;">{{importeNeto | currency:'MXN'}}</td>
            </tr>

            <tr>
              <th colspan="2" style="text-align: right; color: #2054A1; padding-right: 45px;">Arancel CAT</th>
              <td style="text-align: center;" *ngIf="porcentajeCAT != null">{{porcentajeCAT | currency:'MXN'}}</td>
              <td style="text-align: center;" *ngIf="porcentajeCAT == null">$0.00</td>
            </tr>

            <tr>
              <td colspan="3">
                <h4>TARIFAS PARA CORRESPONSABLES</h4>
                <small>Los porcentajes e importes expresados son adicionales al cobro de concepto de Dirección
                  Responsable de Obra</small>
              </td>
            </tr>

            <br>

            <tr *ngFor="let data of dataSource.data">
              <th style="text-align: left;">{{data.corresponsal}}</th>
              <td style="text-align: center;">{{data.arancel | currency:'MXN'}}</td>
              <td style="text-align: center;">{{data.porcentaje}}%</td>
            </tr>

            <br>

            <tr>
              <td colspan="3" style="text-align: right; color: #2054A1;">Estos importes no incluyen I.V.A.</td>
            </tr>

            <br>

            <tr>
              <td colspan="3">
                <small>Los Corresponsables en Instalaciones Electro-Mecánicas en Edificaciones se sujetarán al Arancel
                  establecido por el CIME Tabasco.</small>
                <br>
                <small>Los importes indicados incluyen la Cuota por Arancel al Colegio Respectivo.</small>
              </td>
            </tr>

            <br>

            <tr>
              <th style="text-align: left;" colspan="3">N° D.R.O.</th>
            </tr>
            <tr>
              <td colspan="3" style="text-align: left;">{{dro}}</td>
            </tr>

            <tr>
              <th style="text-align: left;" colspan="3">N° Corresponsable</th>
            </tr>
            <tr>
              <td colspan="3" style="text-align: left;">0</td>
            </tr>

            <tr>
              <th style="text-align: left;" colspan="3">Trámite para</th>
            </tr>
            <tr>
              <td colspan="3">-----------</td>
            </tr>

            <br><br>

            <tr>
              <th colspan="3" style="text-align: center;">
                _________________________________________<br>Firma
              </th>
            </tr>
          </table>
        </td>
      </tr>
    </table>

    <!-- <table style="width: 100%; font-size: 8px; position: fixed; bottom: 0%; color: #2054A1 !important;" >
      <tr>
        <td>
          Dirección
          Calle Ramón Galguera Noverola #106
          Col. Reforma, Villahermosa,
          Tabasco C.P. 86080
          <br>
          Teléfono
          01 993 315 49 62
        </td>
        <td>
          <img src="https://arquitab.org.mx/assets/img/FCARM_light.png" width="25">
        </td>
        <td>
          <img src="https://arquitab.org.mx/assets/img/colegios_arquitectos_r3_small.png" width="90">
        </td>
        <td>
          <img src="https://arquitab.org.mx/assets/img/UIA_full.png" width="100">
        </td>
      </tr>
      <tr>
        <td colspan="4" style="text-align: center;">
          © {{currentDate | date: "yyyy"}} Colegio de Arquitectos Tabasqueños A.C.
        </td>
      </tr>
    </table> -->
    <!---End Primera hoja de la cotización-->

    <div class="pagebreak"></div>

    <!---Segunda hoja de la cotización-->
    <table style="width: 100%;">
      <tr>
        <td style="width: 15;">
          <img src="https://arquitab.org.mx/assets/img/logo_cotizacion_2.png" width="50">
        </td>
        <th style="width: 70; font-size: 11.5px;">
          ARANCEL DE TARIFA MÍNIMA APLICABLE POR D.R.O. Y
          CORRESPONSABLE
          PARA OBRA NUEVA O AMPLIACIÓN EN EL ESTADO DE TABASCO
        </th>
        <td style="width: 15; text-align: right;">
          <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS9prV8FFAA3lytEXResANGi9cG6mcKMwuUyw&usqp=CAU"
            width="50">
        </td>
      </tr>
    </table>

    <table style="width: 100%; font-size: 11.5px !important;">
      <tr>
        <td style="width: 50%; vertical-align: baseline;">
          <table>
            <tr>
              <th style="text-align: left;">Trámite para:</th>
            </tr>
            <tr>
              <td>-----------</td>
            </tr>

            <tr>
              <th style="text-align: left;">Obra:</th>
            </tr>
            <tr>
              <td>{{obra}}</td>
            </tr>

            <tr>
              <th style="text-align: left;">Ubicación:</th>
            </tr>
            <tr>
              <td>{{ubicacion}}</td>
            </tr>

            <tr>
              <th style="text-align: left;">Propietario:</th>
            </tr>
            <tr>
              <td>{{propietario}}</td>
            </tr>

            <tr>
              <th style="text-align: left;">Nombre D.R.O. y/o Corresponsable:</th>
            </tr>
            <tr>
              <td>{{fullNameSocioDesencriptado}}</td>
            </tr>

          </table>
        </td>

        <td style="width: 50%; vertical-align: baseline;">
          <table>
            <tr>
              <th style="text-align: right;">Superficie a construir:</th>
              <td>{{calculoCotizacion.metros2}} m²</td>
            </tr>

            <tr>
              <th style="text-align: right;">Folio:</th>
              <td style="color: red;">SIN VALOR</td>
            </tr>

            <tr>
              <td colspan="2">Sello Colegio:</td>
            </tr>
            <tr>
              <td colspan="2"
                style="padding-bottom: 200px; border: 1px solid black !important; border-collapse: collapse !important;">
              </td>
            </tr>

            <tr>
              <th style="text-align: left;">N° D.R.O.</th>
              <td>{{dro}}</td>
            </tr>

            <tr>
              <th style="text-align: left;">N° Corresponsable</th>
              <td>0</td>
            </tr>
          </table>

        </td>
      </tr>
    </table>

    <!-- <table style="width: 100%; font-size: 8px; position: fixed; bottom: 0%; color: #2054A1 !important;" >
      <tr>
        <td>
          Dirección
          Calle Ramón Galguera Noverola #106
          Col. Reforma, Villahermosa,
          Tabasco C.P. 86080
          <br>
          Teléfono
          01 993 315 49 62
        </td>
        <td>
          <img src="https://arquitab.org.mx/assets/img/FCARM_light.png" width="25">
        </td>
        <td>
          <img src="https://arquitab.org.mx/assets/img/colegios_arquitectos_r3_small.png" width="90">
        </td>
        <td>
          <img src="https://arquitab.org.mx/assets/img/UIA_full.png" width="100">
        </td>
      </tr>
      <tr>
        <td colspan="4" style="text-align: center;">
          © {{currentDate | date: "yyyy"}} Colegio de Arquitectos Tabasqueños A.C.
        </td>
      </tr>
    </table> -->
    <!---End Segunda hoja de la cotización-->
  </div>
</div>
<!----End Plantilla HTML para generar el PDF e imprimirlo-->